import { createContext, useContext, useState, useEffect } from 'react';
import api from '@/api';

const DEFAULTS = {
  clients: 'Клиенты', client: 'Клиент', clientGen: 'клиента',
  appointment: 'Встреча', appointments: 'Встречи', appointmentGen: 'встречи',
  session: 'Сессия', service: 'Услуга', services: 'Услуги',
  format: 'Формат встречи', formats: 'Форматы встреч',
  doctor: 'Специалист', doctors: 'Специалисты', specialist: 'Специалист',
  clinic: 'Организация', schedule: 'Расписание', booking: 'Запись',
  queue: 'Очередь', diagnosis: '', notes: 'Заметки', card: 'Карточка',
};

const IndustryContext = createContext({
  industryType: 'GENERAL',
  terms: DEFAULTS,
  isMedical: false,
  t: (key) => DEFAULTS[key] || key,
});

export const useIndustry = () => useContext(IndustryContext);

export function IndustryProvider({ children }) {
  const [industryType, setIndustryType] = useState('GENERAL');
  const [terms, setTerms] = useState(DEFAULTS);

  useEffect(() => {
    if (document.cookie.includes('pp_csrf')) {
      api.get('/industry-terms')
        .then(({ data }) => {
          setIndustryType(data.industry_type || 'GENERAL');
          setTerms({ ...DEFAULTS, ...(data.terms || {}) });
        })
        .catch(() => {});
    }
  }, []);

  const t = (key) => terms[key] || DEFAULTS[key] || key;

  return (
    <IndustryContext.Provider value={{ industryType, terms, isMedical: industryType === 'MEDICAL', t }}>
      {children}
    </IndustryContext.Provider>
  );
}
